import React from 'react';
import { List, Datagrid, 
		TextField, DeleteButton  } from 'admin-on-rest';
import DeleteLogsButton from './DeleteLogsButton';
import { CardActions } from 'material-ui/Card';
import { RefreshButton } from 'admin-on-rest';

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const LogActions = ({ resource, filters, displayedFilters, filterValues, basePath, showFilter }) => (
    <CardActions style={cardActionStyle}>
        {filters && React.cloneElement(filters, { resource, showFilter, displayedFilters, filterValues, context: 'button' }) }
        <RefreshButton />
       
        <DeleteLogsButton />
    </CardActions>
);


export const AdminlogList = (props) => (
    <List title="Logs" perPage={50} actions={<LogActions />} {...props}>
        <Datagrid >
					
			<TextField source="subject" sortable={false} />
            <TextField source="message" sortable={false} />
            
			<DeleteButton />
			
		</Datagrid>
    </List>
);



// WEBPACK FOOTER //
// ./src/adminlog/Adminlog.js